// complex-secondaty-tabs-utils.js
;(({ $, $$ }) => {
    const secondaryTabs = $$('.complex-secondary-tabs')

    secondaryTabs.forEach(secondaryTabs => {
        const tabButtons = secondaryTabs.querySelectorAll('.tab')
        updateCounterVisibility(tabButtons)       
    })

    function updateCounterVisibility(tabButtons) {
        tabButtons.forEach(tab => {
            const counter = tab.querySelector('.complex-secondary-tabs__tab-counter')
            if (!counter) return

            const counterValue = parseInt(counter.innerHTML.trim())
            
            counter.style.display = counterValue && counterValue > 0 ?
                'flex' : 'none'
        })
    }

    CNS.$fns.setSecondaryTabMessageCounterByIndex = function(tabsGroupName, index, count) {
        const tabsGroup = $(`.complex-secondary-tabs[data-tabs-group="${tabsGroupName}"]`)
        if (!tabsGroup) {
            console.warn(`cannot find tabs group with name: ${tabsGroupName}`)
            return
        }
        
        const secondaryTabs = tabsGroup.querySelectorAll('.tab')
        try {
            if (secondaryTabs[index]) {
                secondaryTabs[index].querySelector('.complex-secondary-tabs__tab-counter')
                    .innerHTML = count
    
                updateCounterVisibility(secondaryTabs)
            }
        } catch (e) {
            console.warn(e)
        }
    }

    CNS.$fns.setSecondaryTabMessageCounterByName = function(tabsGroupName, name, count) {
        const tabsGroup = $(`.complex-secondary-tabs[data-tabs-group="${tabsGroupName}"]`)
        if (!tabsGroup) {
            console.warn(`cannot find tabs group with name: ${tabsGroupName}`)
            return
        }

        const secondaryTabs = tabsGroup.querySelectorAll('.tab')
        
        try {
            let shouldUpdate = false

            secondaryTabs.forEach(tab => {
                const { tabName } = tab.dataset

                if (tabName == name) {
                    tab.querySelector('.complex-secondary-tabs__tab-counter')
                        .innerHTML = count
                    shouldUpdate = true
                }
            })

            if (shouldUpdate) {
                updateCounterVisibility(secondaryTabs)
            } else {
                console.warn(`Tab "${name}" not found`)
            }
        } catch (e) {
            console.warn(e)
        }
    }
})(CNS);
